import { Alert, Button } from "reactstrap";
import PlaylistData from "../data/PlaylistData";
import { useTranslation } from "react-i18next";
import { CyPlaylist } from "../CyPlaylist";
import { useOnlineOffline } from "../../common/hooks/useOnlineOffline";
import { useSavePreviewAsOwnPlaylist } from "./useSavePreviewAsOwnPlaylist";

interface Props {
  playlistData: PlaylistData;
}

/**
 * Explains a preview. Online, the real playlist would already have replaced it, so the person has no access to it;
 * offline, it may still arrive.
 */
export function PreviewInfo({ playlistData }: Props) {
  const { t } = useTranslation();
  const isOnline = useOnlineOffline();
  const saveAsOwnPlaylist = useSavePreviewAsOwnPlaylist();

  return (
    <Alert color="secondary" fade={false} data-cy={CyPlaylist.PreviewInfo}>
      <p>
        <strong>{t("playlist.preview.title")}</strong>
      </p>
      <p>
        {isOnline
          ? t("playlist.preview.descriptionNoAccess")
          : t("playlist.preview.descriptionOffline")}
      </p>
      <Button
        color="link"
        onClick={() =>
          saveAsOwnPlaylist({
            id: playlistData.id,
            songIds: playlistData.getItems().map((i) => i.songEntryId),
          })
        }
        className="p-0 m-0"
        data-cy={CyPlaylist.ButtonSaveAsOwnPlaylist}
      >
        {t("playlist.preview.saveAsOwnPlaylist")}
      </Button>
    </Alert>
  );
}
